import { render, staticRenderFns } from "./dataLayout.vue?vue&type=template&id=14536490&scoped=true&"
import script from "./dataLayout.vue?vue&type=script&lang=js&"
export * from "./dataLayout.vue?vue&type=script&lang=js&"
import style0 from "./dataLayout.vue?vue&type=style&index=0&id=14536490&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14536490",
  null
  
)

export default component.exports